import React from "react";

import { Grid } from "@mui/material";

import { ContainerStatus } from "../../../models/marine.traffic";
import EventContainer from "./components/EventContainer";

interface Props {
  containerStatus?: ContainerStatus;
  containerName?: string;
  containerSize?: string;
  grossWeight?: string;
  shipmentHasTracking?: boolean;
  isEventOpened?: boolean;
  onToggleEventOpened?: () => void;
  isAirTracking?: boolean;
}

const Events = ({
  containerStatus,
  containerName,
  containerSize,
  grossWeight,
  shipmentHasTracking = true,
  isEventOpened = false,
  onToggleEventOpened,
  isAirTracking,
}: Props) => {
  return (
    <Grid container item>
      <Grid item xs={12}>
        <EventContainer
          isAirTracking={isAirTracking}
          shipmentHasTracking={shipmentHasTracking}
          containerStatus={containerStatus}
          containerName={containerName}
          grossWeight={grossWeight}
          isEventOpened={isEventOpened}
          onToggleEventOpened={onToggleEventOpened}
          containerSize={containerSize}
        />
      </Grid>
    </Grid>
  );
};

export default Events;
